export default __webpack_public_path__ + "static/media/ag-icon.167fbd04.svg";